<script lang="ts">
	//Stores
	import { sidePanelState } from 'src/stores/ui/sidepanel-public';
	//Design System Components
	import { SidepanelLayout, SidepanelTabs } from '@Shelly/shelly-design-system';
	//Helpers
	import { checkIsComponent } from 'src/components/Sidepanel/sidepanel-helpers';
	import {
		deviceTabsConfig,
		handleSidePanelTabClick,
	} from 'src/components/Sidepanel/sidepanel-tabs-helpers';
	//Components
	import Main from './Tabs/Main.svelte';
	import Action from './Tabs/Action.svelte';
	import Info from './Tabs/Info.svelte';

	const DEVICE_SIDE_PANEL_CONTENT_CONFIG = [Main, Action, Info];

	let tabIndex: number = 0;
	let tabs = deviceTabsConfig;

	const onTabClick = (e: CustomEvent) => {
		const selectedTabData = e.detail;
		tabIndex = selectedTabData.index;
		tabs = handleSidePanelTabClick(tabs, tabIndex);
	};

	const resetActiveTab = () => {
		tabIndex = 0;
		tabs = deviceTabsConfig;
	};

	const handleSettings = () => {
		console.log('IR_REM-1-remote Sidepanel Settings clicked');
	};

	$: !$sidePanelState.open ? resetActiveTab() : null;
</script>

<SidepanelLayout title="IR_REM-1-remote Device" subtitle="Device Panel" onSettings={handleSettings}>
	<svelte:component this={checkIsComponent(DEVICE_SIDE_PANEL_CONTENT_CONFIG?.[tabIndex])} />
	<SidepanelTabs slot="tabs" {tabs} on:tabClick={onTabClick} />
</SidepanelLayout>
